import { useEffect } from 'react';
import { useNexaStore, getEntrypointParams } from '../NexaStore';
import { NEXA_QUERY_RETRY_CLICK } from '../utils';

interface UseRetryHandlerProps {
  fetchStream: (params: { query: string; diagnostic?: any; analysis_id?: number }) => void;
}

export const useRetryHandler = ({ fetchStream }: UseRetryHandlerProps) => {
  useEffect(() => {
    const handler = (e: CustomEvent) => {
      const retryQuery = e.detail;

      // Check if this is a retry of the first user message
      const events = useNexaStore.getState().events;
      const firstUserEvent = events.find((event) => event.author === 'user');
      const isRetryingFirstMessage = firstUserEvent && firstUserEvent.value === retryQuery;

      const fetchParams: any = { query: `retry: ${retryQuery}` };

      // Only inject entrypoint params if retrying the first user message
      if (isRetryingFirstMessage) {
        const entrypointParams = getEntrypointParams();
        if (entrypointParams) {
          if (entrypointParams.analysis_id) {
            fetchParams.analysis_id = entrypointParams.analysis_id;
          }
          if (entrypointParams.diagnostic_type) {
            fetchParams.diagnostic = {
              type: entrypointParams.diagnostic_type,
              params: entrypointParams.diagnostic_params,
            };
          }
        }
      }

      fetchStream(fetchParams);
    };

    window.addEventListener(NEXA_QUERY_RETRY_CLICK, handler as EventListener);
    return () => window.removeEventListener(NEXA_QUERY_RETRY_CLICK, handler as EventListener);
  }, [fetchStream]);
};
